import { nextTick, onBeforeUnmount, onMounted, ref, watch, Ref } from "vue";

export function useMsgThreadTopIndentDetection(domRefMsgThreadContainer: Ref<HTMLElement | null>, isLoading: Ref<boolean>) {
  const msgThreadContainerViewportTopIndent = ref<number>(0);

  function getMsgThreadViewportTopIndent() {
    if (!domRefMsgThreadContainer.value) {
      return;
    }
    msgThreadContainerViewportTopIndent.value = domRefMsgThreadContainer.value.getBoundingClientRect().top;
  }

  watch(isLoading, async () => {
    await nextTick();
    getMsgThreadViewportTopIndent();
  });

  onMounted(async () => {
    await nextTick();
    getMsgThreadViewportTopIndent();

    window.addEventListener("scroll", getMsgThreadViewportTopIndent);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", getMsgThreadViewportTopIndent);
  });

  return {
    msgThreadContainerViewportTopIndent,
  };
}
